import logo from "../images/brand/logo.png";
import { Link } from "react-router-dom"

function FrontFooter() {
  return (
    <footer className="mt-5 pt-5">
        <div className="container">
        <div className="row">
            <div className="col-md-3 col-6">
            <p className="mb-4" style={{color: 'gray'}}>About</p>
            <Link to="/about" className="text-white text-decoration-none mb-3 d-block">About us</Link>
            <Link to="/whyus" className="text-white text-decoration-none mb-3 d-block">Why Eaglescreener</Link>
            </div>
            <div className="col-md-3 col-6">
            <p className="mb-4" style={{color: 'gray'}}>Earn</p>
            <Link to="/crypto" className="text-white text-decoration-none mb-3 d-block">Crypto</Link>
            <Link to="/forex" className="text-white text-decoration-none mb-3 d-block">Forex</Link>
            <Link to="/stocks" className="text-white text-decoration-none mb-3 d-block">Stocks</Link>
            </div>
            <div className="col-md-3 col-6">
            <p className="mb-4" style={{color: 'gray'}}>Legal</p>
            <Link to="/legal" className="text-white text-decoration-none mb-3 d-block">Legal</Link>
            <Link to="/policy" className="text-white text-decoration-none mb-3 d-block">Privacy policy</Link>
            <Link to="/terms" className="text-white text-decoration-none mb-3 d-block">Terms of service</Link>
            </div>
            <div className="col-md-3 col-6">
            <p className="mb-4" style={{color: 'gray'}}>Support</p>
            <Link to="/faq" className="text-white text-decoration-none mb-3 d-block">FAQ</Link>
            <a href="mailto:support@eaglescreener.com" className="text-white text-decoration-none mb-3 d-block">Send us an email</a>
            </div>
        </div>
        <div className="mt-5 pt-5">
            <img src={logo} alt="logo" className="app-logo"/>
            <p className="mt-5">The risk of loss in online trading of stocks, options, futures, currencies, foreign equities, and fixed Income can be substantial.</p>
            <p>Before trading, clients must read the relevant risk disclosure statements on our Warnings and Disclosures page. Trading on margin is only for experienced investors with high risk tolerance. You may lose more than your initial investment. For additional information about rates on margin loans, please see Margin Loan Rates. Security futures involve a high degree of risk and are not suitable for all investors. The amount you may lose may be greater than your initial investment.</p>
            <p>For trading security futures, read the Security Futures Risk Disclosure Statement. Structured products and fixed income products such as bonds are complex products that are more risky and are not suitable for all investors. Before trading, please read the Risk Warning and Disclosure Statement.</p>
            <p>© 2016 - 2025 Eaglescreener, Inc. All rights reserved.</p>
        </div>
        </div>
    </footer>
  )
}

export default FrontFooter